// // jQuery Custom Functions
// jQuery.fn.extend({
//     checkCollapse: function () {
//         if ($(this).prop("checked")) {
//             $($(this).data("target")).collapse("show");
//         } else {
//             $($(this).data("target")).collapse("hide");
//         }
//     },
//     slugify: function () {
//         var slug_id = $(this).data("slugify")
//         var slug_field = $(slug_id);
//         if ($(this).val()) {
//             var slug = $(this).val()
//                 .replace(/\s+/g, '-') // Replace spaces with -
//                 .replace(/[^\w\-]+/g, '') // Remove all non-word chars
//                 .replace(/\-\-+/g, '-') // Replace multiple - with single -
//                 .replace(/^-+/, '') // Trim - from start of text
//                 .replace(/-+$/, ''); // Trim - from end of text
//             slug_field.val(slug);
//         }
//         $(this).change();
//     }
// });
// $(document).ready(function () {
//     let buyRentSelect = $('.control-optional');
//     buyRentSelect.toggleBuyRent = function () {
//         var val = $(this).val();
//         var selected = $(this).find('option[value="' + val + '"]');
//         var buy_or_rent = selected.val();
//         var outer_wrapper = $(this).closest('#property-details');

//         // Optional Wrappers
//         var optional_buy_wrapper = outer_wrapper.find('.optional-buy-wrapper');
//         var optional_rent_wrapper = outer_wrapper.find('.optional-rent-wrapper');

//         // Optional Inputs
//         var optional_buy_input = optional_buy_wrapper.find(':input');
//         var optional_rent_input = optional_rent_wrapper.find(':input');
//         var optional_buy_select = optional_buy_wrapper.find('select');
//         var optional_rent_select = optional_rent_wrapper.find('select');

//         // Show or Hide Inputs
//         if (buy_or_rent == "rent") {
//             optional_rent_wrapper.collapse('show');
//             optional_buy_wrapper.collapse('hide');
//             // optional_buy_input.val("");
//             optional_buy_input.prop('disabled', true);
//             optional_buy_select.prop('disabled', true);
//             optional_rent_input.prop('disabled', false);
//             optional_rent_select.prop('disabled', false);
//         } else if (buy_or_rent == "buy") {
//             optional_rent_wrapper.collapse('hide');
//             optional_buy_wrapper.collapse('show');
//             // optional_rent_input.val("");
//             optional_rent_input.prop('disabled', true);
//             optional_rent_select.prop('disabled', true);
//             optional_buy_input.prop('disabled', false);
//             optional_buy_select.prop('disabled', false);
//         }

//     }
//     buyRentSelect.on('change', buyRentSelect.toggleBuyRent);
//     buyRentSelect.toggleBuyRent();
// });

// $(document).ready(function() {
// 	$('.time-open, .time-close').datepicker({
//         language: 'en',
// 		dateFormat: 'yyyy-mm-dd',
// 		timepicker: true,
// 		dateTimeSeparator: ' ',
// 		timeFormat: 'hh:ii',
//         clearButton: 'true',
//     });
//     let addOpenTimeButton = document.querySelector('.add-open-time');
//     let removeOpenTimeButtons = document.querySelectorAll('.del-open-time');
//     let openTimeTemplate = document.querySelector('#open-time-template .open-time');
//     let openTimes = document.querySelector('.open-times');
//     let deleteOpenTime = function(e) {
//         e.preventDefault();
//         let deleteElement = this.parentNode.parentNode;
//         deleteElement.parentNode.removeChild(deleteElement);
//     }
//     addOpenTimeButton.addEventListener('click', function(e) {
//         e.preventDefault();
//         let newOpenTime = openTimeTemplate.cloneNode(true);
//         openTimes.insertBefore(newOpenTime, addOpenTimeButton);
//         $(newOpenTime.querySelectorAll('.time-open, .time-close')).datepicker({
//             language: 'en',
//             dateFormat: 'yyyy-mm-dd',
//             timepicker: true,
//             dateTimeSeparator: ' ',
//             timeFormat: 'hh:ii',
//             clearButton: 'true',
//         });
//         newOpenTime.querySelector('.del-open-time').addEventListener('click', deleteOpenTime);
//     });
//     for (let i = 0; i < removeOpenTimeButtons.length; i++) {
//         removeOpenTimeButtons[i].addEventListener('click', deleteOpenTime);
//     }
// });

$(() => {
    $('.property-carousel').slick({
        autoplay: true,
        dots: true,
    });
});